import React from 'react';
import { TableCell, TableRow, Chip } from '@material-ui/core';
import {
  SubscriptionServicePayType,
  SubscriptionServicePayTypeText,
} from '../../data/common';
import moment from 'moment';
import { formatNumberComma } from '../../Util/Util';

const UserSubscriptionServiceTableRow = (props) => {
  const { userSubscriptionService } = props;

  return (
    <TableRow>
      <TableCell component="th">{userSubscriptionService.id}</TableCell>
      <TableCell component="th" title={userSubscriptionService.userId}>
        {userSubscriptionService.userInfo.realName}
      </TableCell>
      <TableCell>
        {userSubscriptionService.subscriptionServiceInfo && (
          <div>
            {userSubscriptionService.subscriptionServiceInfo.serviceName}
          </div>
        )}
      </TableCell>
      <TableCell>
        $ {formatNumberComma(userSubscriptionService.payPrice)}
      </TableCell>
      <TableCell>
        {moment(userSubscriptionService.createdDate).format(
          'YYYY-MM-DD HH:mm:ss',
        )}
      </TableCell>
      <TableCell>
        {moment(userSubscriptionService.startDate).format('YYYY-MM-DD')}
      </TableCell>
      <TableCell>
        {moment(userSubscriptionService.endDate).format('YYYY-MM-DD')}
      </TableCell>
      <TableCell>
        <Chip
          size="small"
          color={
            userSubscriptionService.payType ===
            SubscriptionServicePayType.OFFLINE_PAY
              ? 'secondary'
              : 'primary'
          }
          label={
            SubscriptionServicePayTypeText[userSubscriptionService.payType]
          }
        />
      </TableCell>
      <TableCell>
        {userSubscriptionService.orderInfo
          ? userSubscriptionService.orderInfo.id
          : ''}
      </TableCell>
      <TableCell title={userSubscriptionService.createUserInfo.id}>
        {userSubscriptionService.createUserInfo.realName}
      </TableCell>
    </TableRow>
  );
};

export default UserSubscriptionServiceTableRow;
